import { $Enums } from '@vae/server/dist/client'
import { ConsumptionChartData } from '@vae/server/src/utils/arrays/types/ChartData'
import React from 'react'
import { TimespanOption } from '../../../chartUtils/hooks/useChartTime'
import BaseTooltip from '../../../components/baseTooltip/BaseTooltip'
import getTimeString from '../../../components/baseTooltip/getTimeString'

interface ConsumptionTooltipProps {
	activeElement: number
	isLoading: boolean
	timespan: TimespanOption
	labels: string[]
	tooltipData: any[]
	chartData: ConsumptionChartData | null
	setActiveElement: React.Dispatch<React.SetStateAction<number>>
	language: $Enums.Language
}

const ConsumptionTooltip: React.FC<ConsumptionTooltipProps> = ({
	activeElement,
	isLoading,
	timespan,
	labels,
	tooltipData,
	chartData,
	setActiveElement,
	language,
}) => {
	const selectedLocalTime = chartData?.consumption.groupedData[activeElement]?.localTime
	const selectedLabel = labels[activeElement]
	const time = getTimeString(selectedLocalTime ?? null, selectedLabel, timespan, language)

	return (
		<BaseTooltip
			isLoading={isLoading}
			time={time}
			activeElement={activeElement}
			setActiveElement={setActiveElement}
			upperLimit={labels.length}
			tooltipData={tooltipData}
			activeTimeSpan={timespan}
		/>
	)
}

export default ConsumptionTooltip
